/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const HANDLE_ERROR_MESSAGE_SR = 'HANDLE_ERROR_MESSAGE_SR';
export const GET_SYSTEM_REMINDER_LIST = 'GET_SYSTEM_REMINDER_LIST';
